export default __webpack_public_path__ + "static/havens-8b1d42776e1904e4a1f0e0b545eb5c67.jpg";